import { Utils } from "./Utils";
export class Timer {
    constructor(autoActive, greedyMode) {
        this.scale = 1;
        this.currFrame = 0;
        this.delta = 0;
        this.unscaledDelta = 0;
        this._map = {};
        this._handlers = [];
        (autoActive || autoActive == null) && Timer.gSysTimer && Timer.gSysTimer.frameLoop(1, this, this._update);
        this.currTimer = Date.now();
        this._lastTimer = Date.now();
        this._greedy = !!greedyMode;
    }
    get totalTime() {
        return this._lastTimer;
    }
    _update() {
        if (this.scale <= 0) {
            this._lastTimer = Date.now();
            this.delta = 0;
            return;
        }
        let frame = this.currFrame = this.currFrame + this.scale;
        let now = Date.now();
        this.unscaledDelta = now - this._lastTimer;
        let awake = this.unscaledDelta > 30000;
        this.delta = this.unscaledDelta * this.scale;
        let timer = this.currTimer = this.currTimer + this.delta;
        this._lastTimer = now;
        let handlers = this._handlers;
        let killed = 0;
        for (let i = 0, n = handlers.length - 1; i <= n; i++) {
            let handler = handlers[i];
            if (handler.method) {
                let t = handler.userFrame ? frame : timer;
                if (t >= handler.exeTime) {
                    if (handler.repeat) {
                        if (!handler.jumpFrame || awake) {
                            handler.exeTime += handler.delay;
                            handler.run(false);
                            if (t > handler.exeTime) {
                                handler.exeTime += Math.ceil((t - handler.exeTime) / handler.delay) * handler.delay;
                            }
                        }
                        else {
                            while (t >= handler.exeTime) {
                                handler.exeTime += handler.delay;
                                handler.run(false);
                            }
                        }
                    }
                    else {
                        handler.run(true);
                    }
                }
            }
            else
                killed++;
            i === n && this._greedy && (n = handlers.length - 1);
        }
        if (killed > 30 || frame % 200 === 0)
            this._clearHandlers();
    }
    _clearHandlers() {
        let handlers = this._handlers;
        let j = 0;
        for (let i = 0, n = handlers.length; i < n; i++) {
            let handler = handlers[i];
            if (handler.method !== null) {
                if (j !== i)
                    handlers[j++] = handler;
                else
                    j++;
            }
            else {
                if (this._map[handler.key] == handler)
                    delete this._map[handler.key];
                handler.clear();
                Timer._pool.push(handler);
            }
        }
        handlers.length = j;
    }
    _create(useFrame, repeat, delay, caller, method, args, coverBefore) {
        let key = Utils.getGID(caller, method);
        if (coverBefore == null || coverBefore) {
            let handler = this._map[key];
            if (handler) {
                handler.repeat = repeat;
                handler.userFrame = useFrame;
                handler.delay = delay;
                handler.caller = caller;
                handler.method = method;
                handler.args = args;
                handler.exeTime = delay + (useFrame ? this.currFrame : this.currTimer + Date.now() - this._lastTimer);
                return handler;
            }
        }
        let handler = Timer._pool.length > 0 ? Timer._pool.pop() : new TimerHandler();
        handler.key = key;
        handler.repeat = repeat;
        handler.userFrame = useFrame;
        handler.delay = delay;
        handler.caller = caller;
        handler.method = method;
        handler.args = args;
        handler.exeTime = delay + (useFrame ? this.currFrame : this.currTimer + Date.now() - this._lastTimer);
        this._map[key] = handler;
        this._handlers.push(handler);
        return handler;
    }
    once(delay, caller, method, args, coverBefore) {
        this._create(false, false, delay, caller, method, args, coverBefore);
    }
    loop(delay, caller, method, args, coverBefore, jumpFrame) {
        let handler = this._create(false, true, delay, caller, method, args, coverBefore);
        if (handler)
            handler.jumpFrame = jumpFrame;
    }
    frameOnce(delay, caller, method, args, coverBefore) {
        this._create(true, false, delay, caller, method, args, coverBefore);
    }
    frameLoop(delay, caller, method, args, coverBefore) {
        this._create(true, true, delay, caller, method, args, coverBefore);
    }
    toString() {
        return " handlers:" + this._handlers.length + " pool:" + Timer._pool.length;
    }
    clear(caller, method) {
        let handler = this._map[Utils.getGID(caller, method)];
        if (handler) {
            handler.clear();
        }
    }
    clearAll(caller) {
        if (!caller)
            return;
        for (let i = 0, n = this._handlers.length; i < n; i++) {
            let handler = this._handlers[i];
            if (handler.caller === caller) {
                handler.clear();
            }
        }
    }
    callLater(caller, method, args) {
        Timer.callLaters._create(false, false, 0, caller, method, args, true).exeTime = 0;
    }
    runCallLater(caller, method, forceRun) {
        if (!Timer.callLaters.runTimer(caller, method) && forceRun)
            method.apply(caller);
    }
    clearCallLater(caller, method) {
        Timer.callLaters.clear(caller, method);
    }
    runTimer(caller, method) {
        let handler = this._map[Utils.getGID(caller, method)];
        if (handler && handler.method != null) {
            this._map[handler.key] = null;
            handler.run(true);
            return true;
        }
        else
            return false;
    }
    pause() {
        this.scale = 0;
    }
    resume() {
        this.scale = 1;
    }
    destroy() {
        for (let i = 0, n = this._handlers.length; i < n; i++) {
            let handler = this._handlers[i];
            handler.clear();
        }
        this._handlers.length = 0;
    }
}
Timer.gSysTimer = null;
Timer.callLaters = new Timer(false, true);
Timer._pool = [];
class TimerHandler {
    clear() {
        this.caller = null;
        this.method = null;
        this.args = null;
    }
    run(withClear) {
        let caller = this.caller;
        if (caller && caller.destroyed)
            return this.clear();
        let method = this.method;
        let args = this.args;
        withClear && this.clear();
        if (method == null)
            return;
        args ? method.apply(caller, args) : method.call(caller);
    }
}
